export default __webpack_public_path__ + "static/media/desktop_dr_04.bbb0f2ee.png";